import { AuditDashboardStats } from "../../types";

interface AuditKpiCardsProps {
  stats: AuditDashboardStats;
}

const cards = [
  { key: "active", label: "Task attive", icon: "⚡", accent: "from-indigo-500 to-violet-600" },
  { key: "completed", label: "Completate", icon: "✓", accent: "from-emerald-500 to-teal-600" },
  { key: "overdue", label: "In ritardo", icon: "!", accent: "from-red-500 to-rose-600" },
  { key: "overall", label: "Progresso team", icon: "%", accent: "from-[#cd212a] to-[#2e436a]" },
] as const;

export default function AuditKpiCards({ stats }: AuditKpiCardsProps) {
  const b = stats.status_breakdown;
  const values: Record<string, string | number> = {
    active: b.active,
    completed: b.completed,
    overdue: b.overdue,
    overall: `${stats.totals.overall_percent ?? 0}%`,
  };

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {cards.map((c) => (
        <div
          key={c.key}
          className="group relative overflow-hidden rounded-2xl border border-white/60 bg-white p-4 shadow-lg shadow-secondary/5 transition hover:-translate-y-0.5 hover:shadow-xl"
        >
          <div
            className={`absolute -right-4 -top-4 h-20 w-20 rounded-full bg-gradient-to-br ${c.accent} opacity-15 blur-xl transition group-hover:opacity-25`}
          />
          <div className="relative flex items-start justify-between">
            <div>
              <p className="text-[11px] font-bold uppercase tracking-wider text-secondary/50">
                {c.label}
              </p>
              <p className="mt-1 text-3xl font-extrabold text-secondary tabular-nums">
                {values[c.key]}
              </p>
            </div>
            <span
              className={`flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br ${c.accent} text-sm font-bold text-white shadow-md`}
            >
              {c.icon}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
